import { defineMessages } from 'utils/intl';

export default defineMessages({
  sendMessage: 'Wyślij wiadomość bezpośrednio do działu przetargów i zapytań',
  contactUs: 'Skontaktuj się z nami',
});
